/**
 * Html5 File Selector
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

export { getDataTransferFiles, getDroppedOrSelectedFiles } from './Html5FileSelector.js';
